import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// Drawn over the still's progress track, with the same colours as the live
// leaderboard (DriverLeaderboardStage's Track and Fill).
const Track = styled.div`
  position: absolute;
  border-radius: 999px;
  overflow: hidden;
  background: var(--color-leaderboard-border);
`;

const Fill = styled.div`
  height: 100%;
  background: var(--color-leaderboard-progress);
`;

const toPercent = (fraction: number) => `${fraction * 100}%`;

/**
 * A driver leaderboard's countdown to its next step. The screenshot can't
 * animate, so the player fills the active range's bar from `from` to `to`
 * across the frame's time on screen. Remount (key) it each time the frame is
 * shown to restart it.
 */
const ProgressOverlay = ({
  progress,
  durationMs,
}: {
  progress: WallboardScreenshots.ProgressOverlay;
  durationMs: number;
}) => {
  const [isFilling, setIsFilling] = useState<boolean>(false);

  useEffect(() => {
    // Start from `from`, then transition to `to` on the next frame.
    const raf = requestAnimationFrame(() => setIsFilling(true));
    return () => {
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <Track
      data-testid="wallboard-progress"
      style={{
        left: toPercent(progress.rect.x),
        top: toPercent(progress.rect.y),
        width: toPercent(progress.rect.width),
        height: toPercent(progress.rect.height),
      }}
    >
      <Fill
        data-testid="wallboard-progress-fill"
        style={{
          width: toPercent(isFilling ? progress.to : progress.from),
          transition: isFilling ? `width ${durationMs}ms linear` : 'none',
        }}
      />
    </Track>
  );
};

export default ProgressOverlay;
